import { gsap, ScrollTrigger } from './gsap';

export function initAnimateIn() {
    initZoomReveal();
}

function initZoomReveal() {
    document.querySelectorAll( '[data-zoom-reveal]' ).forEach( ( container ) => {
        const img = container.querySelector( 'img' );

        const tl = gsap.timeline( {
            scrollTrigger: { trigger: container, start: 'top bottom-=40', once: true },
        } );

        tl.fromTo(
            container,
            { clipPath: 'inset(0 0 100% 0)' },
            { clipPath: 'inset(0 0 0% 0)', duration: 1.2, ease: 'power3.inOut' },
            0
        );

        if ( img ) {
            tl.fromTo(
                img,
                { scale: 1.15, transformOrigin: 'center center' },
                { scale: 1, duration: 1.8, ease: 'power3.out' },
                0
            );
        }
    } );
}
